import { TransactionType, SecurityIssuedIn, CurrencyType } from '@dealstack/shared/lib/generated';
import { DocumentLinkTarget } from '@dealstack/frontend/shared/dataExchange/services/shared/types';

export type ProcessingFile = {
	index: number;
	file: File;
	md5: string;
	dealClassifierId?: string;
	classifierName?: string;
	documentLinks?: DocumentLinkTarget[];
};

export type DuplicateFile = ProcessingFile & {
	numberOfDuplicates?: number;
	subRows?: DuplicateFile[];
	status?: boolean;
	isSelected?: boolean;
};

// Using the enum as a state machine used to determine what modal to show or not show
export enum UploadStatusStep {
	// #1 initial step
	addFiles = 'addFiles',
	// #2 validate the files that are being uploaded, checking if the uploaded files have any duplicates etc
	validateUploads = 'validateUploads',
	// #3 checking if the deal already has this file uploaded
	// checking md5 of files against the deal
	fileDealDuplicate = 'fileDealDuplicate',
	// #4 upload the files
	uploadComplete = 'uploadComplete',
}

export type DocumentIdentity = {
	documentId: string;
	fileId: string;
	documentName: string;
};

// used when uploading files to the deal
export type UploadEntityDetails = {
	transactionId: string;
	buyer?: string;
	seller?: string;
	securityName: string;
	transactionType?: TransactionType;
	/** The stored date-only value, unformatted; formatting it twice shifts the day. */
	transactionDate: string;
	units?: number;
	price?: number;
	issuerName: string;
	securityIssuedIn: SecurityIssuedIn;
	securityCurrency: CurrencyType;
	securityUnitDenominator: number;
};
